import React, { memo } from 'react';
import PropTypes from 'prop-types';

const ManufacturersTableMobile = ({ manufacturers }) => {
  return (
    <div className="cases-table-mobile">
      {manufacturers.map((manufacturer) => {
        return (
          <div key={manufacturer.id} className="case-mobile-row">
            <div className="d-flex space-between m-t-sm">
              <div className="m-r-md flex-1">{manufacturer.name}</div>
            </div>
            <div className="d-flex space-between m-t-sm">
              <div className="secondary">
                {manufacturer.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

ManufacturersTableMobile.propTypes = {
  manufacturers: PropTypes.array,
};

export default memo(ManufacturersTableMobile);
